import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {
    Button, Grid, withStyles, TextField, Paper, Typography, Divider,
    FormControl, FormLabel, RadioGroup, FormControlLabel, Radio
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Field } from 'redux-form';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Moment from 'moment';
import { styles } from '../../../styles';
import { textLabelBold } from "../../meCommon";
import * as actions from '../../../../store/actions/index';
import AlertDialog from '../../../common/AlertDialog';


const message = "Please check your email for User Id";

Moment.locale('en');
const validate = values => {
    const errors = {};
    const required = [];
    required.forEach((field, index) => {
        if (!values[field]) {
            errors[field] = 'Required';
        }
    });
    return errors;
};


class ForgetPassword extends Component {

    constructor(props){
        super(props);
        this.state = {
            email :'',
            errorInEmail: '',
            selectedOption: '',
            userId: '',
            memberId: '',
            Alert: false
        }
    }
    componentDidMount = () => {
        if(this.props.forgetErrMsg) {
            this.props.dispatch(actions.resetErrorMsg);
        }
    }

    handleChange = (event) => {
        let value = event.target.value;
        let name = event.target.name;
        this.setState({[name]: value});
    };


    getPasswordChange = () => {
        // this.props.history.push('/resetPassword');
        const { userId, email, memberId } = this.state;
        let params={};
        params.memberId = memberId;
        params.email = email;
        params.userId = userId;
        if (userId && email) {
            this.props.dispatch(actions.forgetPassword(params, () => {
                this.props.history.push('/resetPassword');
            })); 
        } else {
            this.props.dispatch(actions.forgetUserId(params, () => {
                this.setState({ Alert: true });
            }));
        }
    }

    cancel = () => {
        if(this.state.Alert){
            this.setState({ Alert: false });
        }
        this.props.history.push('/login');
    }

    renderTextField = (props) => {
        const {input, meta, label, error, required, multiline, ...custom} = props;
        // const errName = input.name;
        return (
            <TextField
                name={input.name}
                id={input.name}
                label={label}
                error={(required && meta.touched && meta.pristine) || error}
                helperText={required && meta.touched && ((meta.pristine && <span className="text-danger">{label} is Required</span>)
                || (error && <span className="text-danger">{error}</span>)
                || (meta.warning && <span>{meta.warning}</span>))}
                margin="normal"
                variant="outlined" 
                fullWidth={true}             
                {...input}
                {...custom}
                style={{backgroundColor: 'white'}}
                required={required}
            />
        );
    }    

    renderField = (name, label, value, required, error, password) => {
        return(
            <Field
                name={name} component={this.renderTextField} label={label} required={required}
                error={error} type={password} onChange={this.handleChange}
            />
        )
    }

    renderButton = (label, handler, disabled, variant, color) => {
        return (
            <Button variant={variant || "contained"} color={color || "primary"} onClick={handler} style={{ margin: '0 10px 0 5px', paddingLeft: '20px', paddingRight: '20px'}} disabled={disabled}>
                {label}
                <span style={{ padding: '0 10px' }}>
                    {label === "Submit" && this.props.loading && (
                        <CircularProgress size={16} thickness={2} color='inherit' />
                    )}
                </span>
            </Button>
        );
    }
    
    formActions = () => {
        const { handleSubmit, loading } = this.props;
        return(
            <Grid item key={19} xs={12} sm={12} md={12} lg={12} style={{ padding: "40px 20px 0" }}>
                <Grid container spacing={1} alignItems='center' justify='left'>             
                    {this.renderButton('Submit', handleSubmit(this.getPasswordChange), !this.state.email || this.state.errorInEmail || loading)}
                    {this.renderButton('Cancel', ()=>{ this.props.history.push('/login'); }, loading, "text", "secondary")}
                </Grid>
            </Grid>
        )
    }
    handleSelection = (event) => {
        this.setState({ selectedOption: event.target.value });
    }

    forgetSelection = () => {
        return(
            <Grid container alignItems='center' justify='center'>
                <Grid item key={1} xs={12} sm={12} md={12} lg={12} style={{ paddingTop: "20px" }}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Please make a selection, whether you would like to retrieve user ID or reset the password:</FormLabel>
                        <RadioGroup name="verificationCode" value={this.state.selectedOption} onChange={this.handleSelection}>
                            <FormControlLabel value="userId" control={<Radio />} label="Forgot my User ID" />
                            <FormControlLabel value="password" control={<Radio />} label="Forgot my Password" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item key={2} xs={12} sm={12} md={12} lg={12} style={{ paddingTop: "20px" }}>
                    {this.renderButton('Cancel', ()=>{ this.props.history.push('/login'); }, false, "text", "secondary")}
                </Grid>
            </Grid>
        )
    }
    forgetUserID = () => {
        return(
            <Grid container >
                <Grid item key={1} xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="h6" color="primary">Forgot User ID</Typography>
                    <Divider variant="fullWidth"/>
                </Grid>
                <Grid item key={2} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}>
                    {this.renderField('email', 'Email', this.state.email, true, this.state.errorInEmail)}
                </Grid>
                <Grid item key={3} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}></Grid>
                <Grid item key={4} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}>
                    {this.renderField('memberId', 'Member ID', this.state.memberId, true)}
                </Grid>
                {this.props.forgetErrMsg && 
                    <Grid item key={5} xs={12} sm={12} md={12} lg={12} style={{ padding: "20px" }}>
                        {textLabelBold("body2", this.props.forgetErrMsg, "error")}
                    </Grid>
                }
                { this.formActions()}
            </Grid>
        )
    }
    forgetPassword = () => {
        return(
            <Grid container >
                <Grid item key={1} xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="h6" color="primary">Forgot Password</Typography>
                    <Divider variant="fullWidth"/>
                </Grid>
                <Grid item key={2} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}>
                    {this.renderField('userId', 'User ID', this.state.userId, true)}
                </Grid>
                <Grid item key={3} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}></Grid>
                <Grid item key={4} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}>
                    {this.renderField('email', 'Email', this.state.email, true, this.state.errorInEmail)}
                </Grid>
                <Grid item key={5} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}></Grid>
                <Grid item key={6} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}>
                    {this.renderField('memberId', 'Member ID', this.state.memberId, true)}
                </Grid>
                {this.props.forgetErrMsg && 
                    <Grid item key={7} xs={12} sm={12} md={12} lg={12} style={{ padding: "20px" }}>
                        {textLabelBold("body2", this.props.forgetErrMsg, "error")}
                    </Grid>
                }
                { this.formActions()}
            </Grid>
        )
    }
    render() {
        const { classes } = this.props;
        return(
            <Grid container spacing={1} alignItems='center' justify='center' style={{ margin: "20px"}}>
                <Paper className={classes.paperForm} elevation={2} style={{ width: '60%', padding: "20px"}}>
                    {!this.state.selectedOption && this.forgetSelection()}
                    {this.state.selectedOption && this.state.selectedOption === "userId" && this.forgetUserID()}
                    {this.state.selectedOption && this.state.selectedOption === "password" && this.forgetPassword()}
                </Paper>
                {this.state.Alert && <AlertDialog open={true} message={message} close={this.cancel}/>}
            </Grid>
        )
    }
}

ForgetPassword.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


const mapDispatchToProps = (dispatch) => {
    return { dispatch };
};

const mapStateToprops = (state) => {
    return {
            // errorMessage: state.auth.errorMessage, 
            loading: state.members && state.members.loading,
            forgetErrMsg: state.members && state.members.forgetErrMsg,
        }
};

ForgetPassword = reduxForm({ 
    form: 'forgetPasswordForm' ,
    enableReinitialize: true,
    validate,
    fields: [
        'email'
    ]
})(ForgetPassword);

export default compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToprops, mapDispatchToProps)
)(ForgetPassword); 